import script from "./InicioView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InicioView.vue?vue&type=script&setup=true&lang=ts"

import "./InicioView.vue?vue&type=style&index=0&id=38be9529&lang=css"

const __exports__ = script;

export default __exports__